import apiHandler from "../core/apiHandler";

const creditNoteSaleLookupApi = apiHandler('sale-credit-note-lookup');
export default creditNoteSaleLookupApi;
